function addAdroll() {
  adroll_adv_id = EasyPostConstants.AdrollAdvId;
  adroll_pix_id = EasyPostConstants.AdrollPixId;
  if (adroll_adv_id && adroll_pix_id) {
    var scr = document.createElement("script");
    var host = (("https:" == document.location.protocol) ? "https://s.adroll.com" : "http://a.adroll.com");
    scr.setAttribute('async', 'true');
    scr.type = "text/javascript";
    scr.src = host + "/j/roundtrip.js";
    ((document.getElementsByTagName('head') || [null])[0] || document.getElementsByTagName('script')[0].parentNode).appendChild(scr);
  }
}



// WEBPACK FOOTER //
// ../vendor/adroll.js